import { FETCH_LOTTOS } from "../actions/lottos";

const INITIAL_STATE = {
    lottos: []
};

const lottoReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LOTTOS:
      return {
        ...state,
        lottos: action.lottos
      };
    default:
      return state;
  }
};

export default lottoReducer;